import React, { useState, useRef, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles, useTheme, fade } from "@material-ui/core/styles";

import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonToolbar,
} from "reactstrap";

import ExportView from "./ExportView";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import "./report-header-footer.scss"
import {
  Tooltip,
  Drawer,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Divider,
  Slide,
} from "@material-ui/core";
import FileExportIcon from "mdi-react/FileImportIcon";
import ExportSettingsForm from "./ExportSettingsForm";
import { Publisher } from "../../../../shared/pubsub/publisher.js";
import LinearLoading from "../../../../shared/components/LinearLoading";
import FileDocumentEditOutlineIcon from "mdi-react/FileDocumentEditOutlineIcon";
import { _getNeighborhoods } from "../../../../shared/helpers/apicalls";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import LogoIcon from "mdi-react/StarBoxOutlineIcon";
import SummaryIcon from "mdi-react/FileDocumentEditOutlineIcon";
import DetailsIcon from "mdi-react/FormatListCheckboxIcon";
import SettingsIcon from "mdi-react/CogIcon";
import ChartIcon from "mdi-react/ChartAreasplineIcon";
import EditIcon from "mdi-react/PencilIcon";
import PreviewIcon from "mdi-react/EyeOutlineIcon";
import Fab from "@material-ui/core/Fab";
import CloseIcon from "mdi-react/CloseIcon";
import ChevronUpIcon from "mdi-react/ChevronUpIcon.js";
import ChevronDownIcon from "mdi-react/ChevronDownIcon.js";
import CustomSkeleton from "./Skeleton.jsx"
const apiUrl = process.env.API_ROOT + "/";
const exportAPIURL = process.env.MP_EXPORT_SERVER;

const drawerWidth = 800; // Set the width of the drawer

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#780F9E !important",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    color: "#FFF !important",
    alignItems: "center",
    padding: "2px 15px",
  },
  appToolBar: {
    // justifyContent: "space-between",
    width: "100% !important",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: drawerWidth,
  },
  toolBar: {
    paddingLeft: 0,
    width: "100%", 
    justifyContent: "center",
  },
  toolBarButtonGroup: {
    justifyContent: "end",
  },
  button: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#9600BF",
    margin: "0px 5px",
    minWidth: 100,
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    "&.activeButton": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#5C1F7A", // Slight background on hover
    },
  },
  fab: {
    fontWeight: 600,
    background: "#780F9E",
    width: 200,
    "&.Mui-disabled": {
      color: "#F5F7FA",
      background: "#DBE0E8",
    },
    "&:hover": {
      background: "#9600BF",
    },
  },
  fabClose: {
    fontWeight: 600,
    borderColor: "#780F9E",
    color: "#780F9E",
    background: "#FFF",
    marginLeft: "5px",
    "&.Mui-disabled": {
      color: "#F5F7FA",
      background: "#DBE0E8",
    },
    "&:hover": {
      background: "#F5F7FA",
    },
  },
  title: {
    textAlign: "left",
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 100,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
    marginBottom: 0,
    minHeight: 0,
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }), // Use dynamic margin based on slider height
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },

  
}));
const searchBarStyles = makeStyles((theme) => ({
  searchBarContainer: {
    width: "100%",
    position: "fixed",
    left: 0,
    top: 60,
    padding: "30px 20px",
    zIndex: 99,
    background: "#78199E",
  },
  appBar: {
    backgroundColor: "#780F9E !important",
    transform: "none !important",
    color: "#FFF !important",
    boxShadow: "none",
    "&.MuiToolbar-gutters": {
      paddingRight: "0px !important",
    },
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: "-24px !important",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0, //theme.spacing(3),
      width: "100%",
      maxWidth: "none",
    },
    "& .c_input-tag": {
      background: "#780F9E",
      color: "#FFF",
    },
    "& .poly_map_launcher": {
      background: "#5C1F7A !important",
    },
    "&.MuiToolbar-gutters": {
      paddingRight: 0,
    },
    "& .mdi-icon": {
      fill: "#FFF",
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "#FFF !important",
    width: "100%",
    ".c_nav-input.MuiInputBase-input": {
      color: "#fff !important",
    },
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7) + " !important",
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "80%",
    },
    color: "#222 !important",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  searchButton: {
    color: "#FFF",
    borderColor: "#FFF",
    backgroundColor: "#5C1F7A",
    margin: "0px 5px",
    "&:hover": {
      borderColor: "#FFF", // A darker shade for the hover state
      backgroundColor: "#B070CC", // Slight background on hover
    },
    minWidth: 120,
    height: 46,
    marginLeft: -40,
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
    "&.Mui-disabled": {
      boxShadow: "none",
      color: "#9600BF",
    },
  },
}));
function formatDate() {
  const date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

const dateFormatted = formatDate();

const sanitizeResults = (result, paragraphs) => {
  let sanitized = result.replace(/undefined/g, "");

  // Remove leading newlines
  sanitized = sanitized.replace(/^\n+/, "");

  // Protect code blocks and inline code from being altered
  sanitized = sanitized.replace(
    /```([^```]*)```/gim,
    "<pre><code>$1</code></pre>"
  );
  sanitized = sanitized.replace(/`([^`]*)`/gim, "<code>$1</code>");

  // Headers
  sanitized = sanitized.replace(/^### (.*$)/gim, "<b>$1</b>");
  sanitized = sanitized.replace(/^## (.*$)/gim, "<b>$1</b>");
  sanitized = sanitized.replace(/^# (.*$)/gim, "<b>$1</b>");

  // Bold and italic
  sanitized = sanitized.replace(/\*\*\*(.+?)\*\*\*/gim, "<b><i>$1</i></b>");

  // Bold
  sanitized = sanitized.replace(/\*\*(.+?)\*\*/gim, "<b>$1</b>");

  // Italic
  sanitized = sanitized.replace(/\*(.+?)\*/gim, "<i>$1</i>");

  // Underline
  sanitized = sanitized.replace(/___(.+?)___/gim, "<u>$1</u>");

  // Links
  sanitized = sanitized.replace(/\[(.+?)\]\((.+?)\)/gim, '<a href="$2">$1</a>');

  // Blockquotes
  sanitized = sanitized.replace(/^\> (.*$)/gim, "<blockquote>$1</blockquote>");

  // Paragraph handling
  if (paragraphs) {
    sanitized = sanitized.replace(/(?:\n|\r|\n\n)+/g, "</p><p>");
    sanitized = `<p>${sanitized}</p>`;
  } else {
    sanitized = sanitized.replace(/(?:\n|\r|\n\n)+/g, "");
  }

  return sanitized;
};

const WritingInProgress = () => {
  const classes = useStyles();

  const phrases = [
    "Interpreting Trends",
    "Analyzing Data",
    "Compiling Insights",
    "Evaluating Metrics",
  ];
  const [currentPhrase, setCurrentPhrase] = useState(phrases[0]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentPhrase((prevPhrase) => {
        const currentIndex = phrases.indexOf(prevPhrase);
        const nextIndex = (currentIndex + 1) % phrases.length;
        return phrases[nextIndex];
      });
    }, 1000); // Change phrase every 2 seconds

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [phrases]);

  return (
    <Typography
      variant="h5"
      noWrap
      className={classes.drawerHeaderTitle}
      style={{ textAlign: "center" }}
    >
      <FileDocumentEditOutlineIcon
        size={32}
        color="#780F9E"
        style={{ marginTop: -5 }}
      />{" "}
      Writing Report ({currentPhrase})...
    </Typography>
  );
};

const ExportModal = (props) => {
  const {
    html,
    user:userProp,
    parentFetchInProgress,
    getUnitList,
    setDetails,
    reportParams,
    renderListViewHTML,
    renderStatsHTML,
    searchTags,
    _renderChartHTML,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [panel, setPanel] = useState(false);
  const [progress, setProgress] = useState("");
  const [orientation, setOrientation] = useState("portrait");
  const [preview, setPreview] = useState(false);
  const [fetchInProgress, setFetchInProgress] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [boundingBoxCoord, setBoundingBoxCoord] = useState([]);
  const [isBoundsAvailable, setIsBoundsAvailable] = useState(false);
  const [aiRun, setAiRun] = useState(false); // State to track if handleAI has been run
  const [aiInProgress, setAIInProgress] = useState(false);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [unitListProgress, setUnitListProgress] = useState(false);
  const [formValuesCheckboxes, setFormValuesCheckboxes] = useState([]);
  const previewContainerRef = useRef(null);
  const [renderedChart, setRenderChart] = useState(null);
  const [showBrandingSlider, setShowBrandingSlider] = useState(false);
  const [showDetailsSlider, setShowDetailsSlider]=useState(false)
  const [isEditMode, setIsEditMode] = useState(false);
  const [sliderHeight, setSliderHeight] = useState(0);
  const [editedContent, setEditedContent] = useState(false);
  const brandingFromStorage=localStorage.getItem("brandingMarketPulse");
  const contactFromStorage=localStorage.getItem("contactMarketPulse");
  const localStorageUser = localStorage.getItem("bl_user");
  const user = localStorageUser ? JSON.parse(localStorageUser) : userProp;
  const defaultValues = {
    reportTitle: "",
    summary: "",
    details: "no-details",
   branding:
    brandingFromStorage || (user && user.logo ? "mylogo" : "marketproof"),
    contact: contactFromStorage ? contactFromStorage : "show",
  };
  const brandingSliderRef = useRef(null);
  const detailsSliderRef=useRef(null);
  const [formValues, setFormValues] = useState(defaultValues);
  const progressRef = useRef("");
  const iframeRef = useRef(null);
  const classes = useStyles();
  const searchClasses = searchBarStyles();
  const theme = useTheme();
  const defaultLogo = user && user.corpLogo ? user.corpLogo : "https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png";

  const updateSliderHeight = () => {
    setTimeout(() => {
      let sliderHeight = 0;

      if (showBrandingSlider && brandingSliderRef.current) {
        sliderHeight = brandingSliderRef.current.offsetHeight;
      }
      if(showDetailsSlider && detailsSliderRef.current){
        sliderHeight = detailsSliderRef.current.offsetHeight;
      }

      setSliderHeight(sliderHeight);
    }, 100); // Delay calculation to wait for rendering
  };

  useEffect(() => {
    updateSliderHeight(); // Calculate the height on initial render and when toggling sliders
  }, [showBrandingSlider, showDetailsSlider]);
  const setIframeContent = (height) => {
    const iframe = iframeRef.current;
    if (iframe) {
      const iframeDoc = iframe.contentDocument;
      iframe.style.height = `${height}px`;
    }
  };

  const styles = Array.from(
    document.querySelectorAll('style, link[rel="stylesheet"]')
  )
    .map((style) => {
      let clonedStyle = style.cloneNode(true);
      if (clonedStyle.tagName.toLowerCase() === "link") {
        const linkElement = clonedStyle;
        const href = linkElement.getAttribute("href");
        const absoluteUrl = new URL(href, document.baseURI).href;
        linkElement.setAttribute("href", absoluteUrl);
      }
      return clonedStyle.outerHTML;
    })
    .join("\n");
    const handleSaveChanges = (updatedContent) => {
      console.log(updatedContent);
      setEditedContent(updatedContent); // Save edited content
    };
    const ReportHeader = () => {
      return (
        <div className="header page-section header-section">
          <div className="export-header">
            <div>
              {formValues &&
              formValues.branding &&
              formValues.branding === "mylogo" &&
              user &&
              user.logo ? (
                <img className="header-logo" src={user.logo} />
              ) : formValues &&
                formValues.branding &&
                formValues.branding === "marketproof" ? (
                <img
                  className="header-logo"
                  src={defaultLogo}
                />
              ) : null}
            </div>
            <div>{ReportContact()}</div>
          </div>
        </div>
      );
    };

  const ReportTitle = () => {
   // if (!formValues || !formValues.reportTitle) return null;
    return (
      <div className="page-section">
        <div className="report-title">
       {!aiRun ? 
         <div className="writing-in-progress">
          <WritingInProgress />
          <CustomSkeleton/>
         </div>:   
         <h2 className="editable">{formValues.reportTitle}</h2>
      }
        </div>
      </div>
    );
  };

  const ReportSummary = () => {
  //  if (!formValues || !formValues.summary) return null;
    return (
      <div className="page-section">
        {console.log(formValues, "formValues")}
        <div className="report-summary-container">
          <div className="report-summary">
          {!aiRun ? 
            <div>
              
              <div style={{display:"flex",gap:"20px",width:"100%"}}>
                <div style={{width:"50%"}}><CustomSkeleton count={24}/></div>
                <div style={{width:"50%"}}><CustomSkeleton count={24}/></div>
              </div>
            </div>
            :  <div
              className="report-content"
              dangerouslySetInnerHTML={{ __html: formValues.summary }}
            />} 
          </div>
        </div>
      </div>
    );
  };

  const ReportFooter = () => {
    return (
      <div className="page-section">
        <div className="report-footer">
          Data by{" "}
          <a
            className="footer__logo"
            href={"https://marketproof.com/"}
            target="_blank"
          >
            <img
              src="https://marketproof-hosting.s3.amazonaws.com/logos/marketproof-logo-horizontal-transparent-background.png"
              style={{ width: 100 }}
            />
          </a>
          {" | "}
          {dateFormatted}
        </div>
      </div>
    );
  };

  const ListHTML = () => {
    if (!formValues.listHTML) return <></>;
    if (formValues.details && formValues.details == "no-details") return <></>;
    return <>{formValues.listHTML}</>;
  };

  const ReportContact = () => {
    if (formValues && formValues.contact && formValues.contact === "show") {
      return (
        <div className="page-section">
          <div className="report-contact">
            <div
              className="avatar-img"
              style={{ backgroundImage: `url(${user.avatar})` }}
              alt="avatar"
            />

            <div>
              <p className="contact-name">
                {user.firstName} {user.lastName}
                <br />
              </p>
              <div className="contact-title">
                {user.title && <span>{user.title}</span>}
                {user.company && (
                  <span>
                    {" | "}
                    {user.company}
                  </span>
                )}

                {user.agentLicenseNumber && (
                  <span>
                    {" "}
                    {" | "}License #: {user.agentLicenseNumber}
                  </span>
                )}
              </div>
              <div className="contact-info">
                {user.email && <span>{user.email}</span>}
                {user.primaryPhone && (
                  <span>
                    {" | "}
                    {user.primaryPhone}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  let htmlContent = (
    <Fragment>
      {ReportTitle()}
      {ReportSummary()}

      {html}
      {ListHTML()}
      {formValuesCheckboxes.includes("showSnapshotBuildingCharts") ? (
        <>{renderedChart}</>
      ) : null}
    </Fragment>
  );

  const headerContent = `
    <style>
    body {
      font-family: Arial, sans-serif;
    }
    .key-stat{
      font-size:30px !important;
    }import { SuccessIcon } from 'mdi-react/CheckCircleOutlineIcon';

    .page-section{
      width:100%;
    }
    .export-header{
      padding: 20px 20px;
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      border-bottom: 1px solid #333;
      justify-content:space-between;
    }
    .report-contact{
      display:flex;
    }
    .report-contact .avatar-img {
      margin-right:10px;
    }
    .report-contact .contact-name{
      font-size:22px;
      font-weight:700;
      line-height:27px;
    }
    .report-contact .contact-title, .report-contact .contact-info{
      font-size:18px;
      font-weight:300;
      line-height:21px;
    }
    .report-contact .avatar-img{
      width:70px;
      height:70px;
      background-size:cover;
      border-radius:50%;
    }
    .report-title{
      margin:20px;
    }
    .report-summary-container{
       min-height:800px;
    }
    .report-summary{
      margin:20px;
      padding:20px;
      background:#F5F7FA;
      margin-bottom:30px;
    }
    .report-summary .report-content{
      font-size:20px;
      column-count:2;
    }
    .report-title h2{
      font-weight: 700;
      text-transform: uppercase;
      padding-bottom: 15px;
      border-bottom: 1px solid #AAA;
      margin-bottom: 30px;
    }
         .editable[contenteditable=true] {
      outline: 1px dashed #FF206E;
      position:relative;
    }
    .editable[contenteditable=true]:hover::before {
      content: "Click to Edit";
      text-transform:uppercase;
      background-color: #FF206E;
      color: #FFF;
      font-weight: bold;
      position: absolute;
      left: 0;
      font-size: 12px;
      line-height: 12px;
      padding: 8px 20px;
      text-align: center;
      height: 30px;
      top: 0;
      display: block;
      font-family: 'Montserrat';
      margin: 0;
      
    }
    .editable[contenteditable=true]:active::before, .editable[contenteditable=true]:focus::before{
      width:0;
      height:0;
      display:none;
    }
    @media print {
      body {
        transform: scale(1); /* Zoom to 80% */
      }
      .editable[contenteditable=true] {
        outline: none;
      }
    }
    </style>
    ${styles}
  `;

  const scripts = `
    <script src="https://cdnjs.cloudflare.com/ajax/libs/react/17.0.2/umd/react.production.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/react-dom/17.0.2/umd/react-dom.production.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/recharts/2.0.10/Recharts.min.js"></script>
  `;

  useEffect(() => {
    const eventSource = new EventSource(`${exportAPIURL}/events`);

    eventSource.onmessage = function (event) {
      const progress = JSON.parse(event.data);
      if (progressRef.current !== progress.status) {
        progressRef.current = progress.status;
        setProgress(`${progress.status}`);
      }
    };

    return () => {
      eventSource.close();
    };
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    //props.setIsExportModalClicked(!isModalOpen);
    if (isModalOpen) {
      setFormValues(defaultValues);
      setAiRun(false);
      // setFormValuesCheckboxes([]);
    }
  };


  const scrollToTop = () => {
    if (previewContainerRef.current) {
      //previewContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
      if (previewContainerRef.current.scrollTop > 0) {
        // Scroll to top
        previewContainerRef.current.scrollTop = 0;
      }
    }
  };
  const closeAllSliders = () => {
    setShowBrandingSlider(false);
  
  };
  console.log(showBrandingSlider, "showBrandingSlider")
  useEffect(() => {
    const fetchData = async () => {
      scrollToTop();
      if (formValues.details !== "no-details") {
        setUnitListProgress(true);
        setIframeContent(1200);
     
        try {
          const unitListTableData = await getUnitList(formValues.details);
          let listHTML;
           
            listHTML = renderListViewHTML(
              unitListTableData,
              formValues.details
            );
          
          setFormValues((prevState) => ({
            ...prevState,
            listHTML: listHTML,
          }));

          setUnitListProgress(false);
        } catch (error) {
          console.error("Error fetching unit list:", error);
        }
      } else {
        setIframeContent(0);
        setUnitListProgress(true);

        setFormValues((prevState) => ({
          ...prevState,
          listHTML: null,
        }));
        setUnitListProgress(false);
      }
    };

    fetchData();
  }, [formValues.details, props.user]);
  const handleClickOutside = function (event) {
    var polyMapModal = document.querySelector(".poly_map__modal");
    var headerElement = document.querySelector("header"); // Assuming your header has a <header> tag. Adjust the selector if needed.
    var popOverElement = document.querySelector(".MuiPopover-root");
    var formControlElement = document.querySelector(".MuiFormControl-root");
    console.log("here");
    // Check if the click is outside the search bar, not within the .poly_map__modal, and not within the header
  
 
    if (
      brandingSliderRef.current &&
      !brandingSliderRef.current.contains(event.target) &&
      !(headerElement && headerElement.contains(event.target)) &&
      !(event.target.closest(".branding-toggle-button")) 
    ) {
      setShowBrandingSlider(false);
    }

    if (
      detailsSliderRef.current &&
      !detailsSliderRef.current.contains(event.target) &&
      !(headerElement && headerElement.contains(event.target)) &&
      !(event.target.closest(".details-toggle-button")) 
    ) {
      setShowDetailsSlider(false);
    }

  };

  useEffect(() => {
    // Add event listener for clicks outside the slider components
    const addOrRemoveClickListener = () => {
      if (
        showBrandingSlider || showDetailsSlider
      ) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };

    addOrRemoveClickListener();

    // Attach click listener to the iframe content document when iframe is available
    const iframe = iframeRef.current;

    if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
      const iframeDoc = iframe.contentWindow.document;
      console.log("has iframe");

      // Attach the mousedown event initially
      const attachMouseDown = () => {
        iframeDoc.addEventListener("mousedown", (event) => {
          const clickEvent = new MouseEvent("mousedown", { bubbles: true });
          if (!editedContent) {
            closeAllSliders();
          }
        });
      };

      // Attach the event initially
      attachMouseDown();

      // Set up a MutationObserver to watch for content changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" || mutation.type === "subtree") {
            // Reattach the event after content changes
            attachMouseDown();
          }
        });
      });

      // Observe changes in the iframe document
      observer.observe(iframeDoc, { childList: true, subtree: true });

      // Disconnect the observer when no longer needed (e.g., on unmount)
      return () => observer.disconnect();
    }

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);

      if (iframe && iframe.contentWindow && iframe.contentWindow.document) {
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.removeEventListener("mousedown", handleClickOutside);
      }
    };
  }, [

    showBrandingSlider,
    showDetailsSlider,
    iframeRef,
  ]);
  // useEffect(() => {
  //   const loadCharts = async () => {
  //     if (
  //       formValuesCheckboxes.includes("showSnapshotBuildingCharts") &&
  //       formValues.details === "no-details"
  //     ) {
  //       setUnitListProgress(true);

  //       const resolvedHtml = await _renderChartHTML(); // Call the function that returns the promise
  //       setRenderChart(resolvedHtml);
  //       setUnitListProgress(false);
  //     }
  //   };

  //   loadCharts();
  // }, [formValuesCheckboxes, formValues]);

  console.log(aiRun , isModalOpen, "AIRUNMODAL")
  useEffect(() => {
    if (!aiRun && isModalOpen) {
      handleAI();
    }
  }, [isModalOpen, aiRun]);

  function calculateBoundingBox(polyHoods) {
    let minLng = Infinity,
      minLat = Infinity,
      maxLng = -Infinity,
      maxLat = -Infinity;

    polyHoods.forEach((polygon) => {
      polygon.coordinates.forEach((coord) => {
        const [lng, lat] = coord.map(Number); // Convert string to number
        if (lng < minLng) minLng = lng;
        if (lat < minLat) minLat = lat;
        if (lng > maxLng) maxLng = lng;
        if (lat > maxLat) maxLat = lat;
      });
    });

    return [
      [minLng, minLat],
      [maxLng, maxLat],
    ];
  }

  useEffect(() => {
    setIsBoundsAvailable(false);
    const fetchNeighborhoods = async () => {
      const url = process.env.API_ROOT + "/query/";

      await _getNeighborhoods(searchTags, {
        callback: (hoods) => {
          if (hoods && searchTags.length) {
            const boundingBox = calculateBoundingBox(hoods);
            setBoundingBoxCoord(boundingBox);
          } else {
            setBoundingBoxCoord([]);
          }
        },
        url: url,
      });
    };

    fetchNeighborhoods();
    setIsBoundsAvailable(true);
  }, [searchTags]);

  const addEditableClass = (htmlString) => {
    return htmlString
      .replace(/<p>/g, '<p class="editable">');  
  };
  const handleAI = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setAIInProgress(true);
    scrollToTop();
    setFormValues((prevState) => ({
      ...prevState,
      reportTitle: "Writing title...",
      summary: "Writing summary...",
      aiRefresh: false,
    }));

    try {
      const [title, summary] = await Promise.all([
        handleAIGenerateTitle(),
        handleAIGenerate(),
      ]);
console.log(summary, "summary")
      setFormValues((prevState) => ({
        ...prevState,
        reportTitle: title,
        summary: addEditableClass(summary),
        aiRefresh: true,
      }));

      setAiRun(true); // Mark as run
    } catch (error) {
      console.error("Error generating title and summary:", error);
    } finally {
      setAIInProgress(false);
    }
  };
  const isSliderOpen = () => {
    return (
       showBrandingSlider || showDetailsSlider
    );
  };
  const sliderOpen = isSliderOpen();
  const handleAIGenerateTitle = async () => {
    const prompt =
      "Write a title for a real estate Market Snapshot report for NYC, just a few words. No quotes. No formatting, just text.";
    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a real estate expert, use the following information.\n\n  The report is filtered by the following parameters: ${JSON.stringify(
            reportParams["reportSettings"]
          )}`,
        },
        { role: "user", content: prompt },
      ],
      model: "gpt-4o",
    };

    const axiosData = {
      url: apiUrl + "ai/chat",
      method: "post",
      query: queryData,
    };

    try {
      const res = await _axiosCall(axiosData);
      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        return sanitizeResults(result);
      }
    } catch (error) {
      console.log("Error generating title:", error);
    }
    return "";
  };

  const handleAIGenerate = async () => {
    const prompt =
      "Write a brief real estate market analysis based on data given, no longer than 240 words. The context is property sales or listings. Your job is to provide readers w/ high-level context about market direction. the analysis should be concise and brief, use the stats provided, e.g. increased XX%. Segment the analysis by market type, e.g. New Development, Luxury, Resale Condo, etc. Speak as the author of the report, do not refer to data or anything technical. Keep it high level. Use only very basic markdown such as bold text formatting. Separate as paragraphs, do not include main heading but each market type should have a subheading using bold text (not heading tags). If there are multiple market types, summarize the whole as well as provide a brief intro. DO NOT EXCEED 250 words.";

    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a real estate expert, use the following information.\n\n  The report is filtered by the following parameters: ${JSON.stringify(
            reportParams["reportSettings"]
          )}
       The report contains the following key stats:${JSON.stringify(
         reportParams["reportData"]
       )}`,
        },
        { role: "user", content: prompt },
      ],
      model: "gpt-4o",
    };

    const axiosData = {
      url: apiUrl + "ai/chat",
      method: "post",
      query: queryData,
    };

    try {
      const res = await _axiosCall(axiosData);
      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        return sanitizeResults(result, true);
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return "";
  };

  const handleExport = async (e) => {
    e.preventDefault();
    setProgress("Submitting...");
    const iframeDoc = iframeRef.current.contentDocument;
    const htmlContent = iframeDoc.documentElement.outerHTML;
    const uniqueId = uuidv4();
    const fileName = `${user.id}/Market-Snapshot-${dateFormatted}-${uniqueId}.pdf`;
    const exportName = `Market-Snapshot-${dateFormatted}-${uniqueId}.pdf`;
    setExportInProgress(true);

    try {
      const response = await fetch(`${exportAPIURL}/generate-pdf-save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          html: htmlContent,
          orientation: "portrait",
          fileName,
        }),
      });

      if (response.ok) {
        const { url } = await response.json();

        const fileResponse = await fetch(url);
        const blob = await fileResponse.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = exportName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);

        setProgress("Download complete");
        setTimeout(() => {
          console.log("Timeout triggered. Setting progress to null.");
          setProgress(null);
        }, 2000);
        setExportInProgress(false);
        const customData = {
          file: url,
        };
        Publisher.publish(`track-mp.aiSnapshotExport`, {
          user: user,
          customData: customData,
        });
      } else {
        console.error("Failed to generate PDF");
        setProgress("Error generating PDF");
        setExportInProgress(false);
      }
    } catch (error) {
      console.error("Error exporting PDF:", error);
      setProgress("Error generating PDF");
      setExportInProgress(false);
    }
  };

  const handleMapLoad = (loaded) => {
    setIsMapLoaded(loaded);
  };
const handleToggleBrandingSlider=()=>{
  setShowBrandingSlider(!showBrandingSlider);
  setShowDetailsSlider(false);
  setIsEditMode(false)
}
const handleDetailsSlider=()=>{
  setShowBrandingSlider(false);
  setShowDetailsSlider(!showDetailsSlider)
  setIsEditMode(false)
}
const handleEditMode=()=>{
  setIsEditMode(!isEditMode);
  setShowBrandingSlider(false);
  setShowBrandingSlider(false);
}
  return (
    <div>
      {/* <Tooltip title="Use AI to write a summary and download this report">
        <Button
          variant="contained"
          color="primary"
          className="buyersList__primary-button"
          startIcon={<FileDocumentEditOutlineIcon />}
          onClick={toggleModal}
          disabled={parentFetchInProgress}
        >
          {" "}
          Write Report
        </Button>
      </Tooltip> */}
      <Tooltip title={`Use AI to write a summary and download this report`}>
        <Fab
          variant="extended"
          size="medium"
          color="secondary"
          aria-label="add"
          className={classes.fab}
          onClick={toggleModal}
          disabled={parentFetchInProgress}
        >
          <FileDocumentEditOutlineIcon style={{ marginRight: 5 }} /> {` `}
          Write Report
        </Fab>
      </Tooltip>

      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="lg"
        className={`modal-dialog pdf_export_modal ${user && user.role && Array.isArray(user.role) ? user.role.join(" ") : ""}`}
        ref={previewContainerRef}
      >
        <div style={{ display: "flex" }}>
          <CssBaseline />
          <AppBar
            position="fixed"
            style={{ zIndex: 1201 }}
            className={`mcAppBar ${classes.appBar}`}
          >
            <Toolbar className={classes.appToolBar}>
              <Typography
                variant="h6"
                noWrap
                className={classes.title}
                style={{  justifyContent: "left", minWidth:"200px" }}
              >
              Preview & Customize
              </Typography>
              
              <Toolbar className={classes.toolBar}>
              <Tooltip title="Upload your logo and change your contact method">
                  <Button
                    startIcon={<LogoIcon />}
                    className={`branding-toggle-button ${classes.button} ${
                      showBrandingSlider ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleToggleBrandingSlider}
                    disabled={fetchInProgress}
                  >
                    {user && user.logo ? "Brand" : "Brand"}
                    {showBrandingSlider ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>
                <Tooltip
                  title={
                    isEditMode
                      ? "Preview report - exit edit mode and remove dotted lines"
                      : "Edit report - editable content marked by dotted lines"
                  }
                >
                  <Button
                    startIcon={isEditMode ? <PreviewIcon /> : <EditIcon />}
                    className={`${classes.button} ${
                      isEditMode ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleEditMode}
                    activated={isEditMode}
                    disabled={fetchInProgress || aiInProgress}
                  >
                    {isEditMode ? "Preview" : "Copy"}
                  </Button>
                </Tooltip>
                <Tooltip title="Choose whether to include details in the report">
                  <Button
                    startIcon={<DetailsIcon />}
                    className={`details-toggle-button ${classes.button} ${
                      showDetailsSlider ? "activeButton" : ""
                    }`} // Apply active class conditionally
                    onClick={handleDetailsSlider}
                    disabled={fetchInProgress || aiInProgress}
                  >
                   {formValues && formValues.details == "no-details" 
                        ? "Details"
                        : "Details"}
                         {showDetailsSlider ? (
                      <ChevronUpIcon size={18} />
                    ) : (
                      <ChevronDownIcon size={18} />
                    )}
                  </Button>
                </Tooltip>
              </Toolbar>
              <div style={{ minWidth:"200px", textAlign: "right" }}>
                {/* <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={toggleDrawer}
                >
                  <ChevronLeftIcon color={"white"} />
                </IconButton> */}
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="end"
                  onClick={() => {
                    if (sliderOpen) {
                      closeAllSliders();
                    } else {
                      toggleModal();
                      setFetchInProgress(false);
                      console.log("modalClose");
                    }
                  }}
                  style={{ marginLeft: 5 }}
                >
                  {sliderOpen ? (
                    <ChevronUpIcon size={18} color={"white"} />
                  ) : (
                    <CloseIcon size={20} color={"white"} />
                  )}
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <Slide
            direction="down"
            in={showBrandingSlider}
            mountOnEnter
            unmountOnExit
          >
            <div
              id="branding-slider"
              className={`appBarSlider ${searchClasses.searchBarContainer}`}
              ref={brandingSliderRef}
            >
              <ExportSettingsForm
                user={user}
                setPreview={() => setPreview(!preview)}
                setParentFetchInProgress={setFetchInProgress}
                formValues={formValues}
                setFormValues={setFormValues}
                {...props}
                defaultValues={defaultValues}
                aiInProgress={aiInProgress}
                setFormValuesCheckboxes={setFormValuesCheckboxes}
                formValuesCheckboxes={formValuesCheckboxes}
                panel={"branding"}
                isDrawerOpen={isDrawerOpen}
                defaultLogo={defaultLogo}
               
              
              />
            </div>
          </Slide>

          <Slide
            direction="down"
            in={showDetailsSlider}
            mountOnEnter
            unmountOnExit
          >
            <div
              id="details-slider"
              className={`appBarSlider ${searchClasses.searchBarContainer}`}
              ref={detailsSliderRef}
            >
              <ExportSettingsForm
                user={user}
                setPreview={() => setPreview(!preview)}
                setParentFetchInProgress={setFetchInProgress}
                formValues={formValues}
                setFormValues={setFormValues}
                {...props}
                defaultValues={defaultValues}
                aiInProgress={aiInProgress}
                setFormValuesCheckboxes={setFormValuesCheckboxes}
                formValuesCheckboxes={formValuesCheckboxes}
                panel={"details"}
                isDrawerOpen={isDrawerOpen}

               
              
              />
            </div>
          </Slide>
          <main
            style={{
              flexGrow: 1,
              padding: "16px",
              marginLeft: 0,
              marginTop: sliderHeight,
            }}
          >
            <div className="pdf_modal_container">
              <div className="pdf_preview">
                <div
                  className="modal__body"
                  style={{
                    height: "100%",
                    minHeight: "calc(100vh - 250px)",
                    padding: 15,
                  }}
                >
                  {/* <div
                    style={{
                      border: "1px solid rgba(0,0,0,.12)",
                      boxShadow: "2px 2px 6px rgba(0,0,0,.12)",
                      paddingTop: 10,
                      paddingLeft: 10,
                      background: "#F5F7FA",
                      minHeight: "calc(100vh - 140px)",
                    }}
                  > */}
                  <div
                    id={"previewContainer"}
                    style={{
                      width: "110%",
                      boxShadow: "2px 2px 6px rgba(0,0,0,.12)",
                      padding: 0,
                      paddingBottom: 0,
                      background: "#F5F7FA",
                      // maxHeight: "calc(100vh - 170px)",
                      // overflowY: "scroll",
                      // overflowX: "hidden",
                      transform: "scale(0.9)",
                      transformOrigin: "0 0",
                      marginBottom: "-20vh",
                    }}
                  >
                    <>
                      
                      {!unitListProgress ? (
                        <ExportView
                          ref={iframeRef}
                          contentHTML={
                            editedContent ? editedContent : htmlContent
                          }
                      
                          headerContent={headerContent}
                          scripts={scripts}
                          headerHTML={<ReportHeader />}
                          footerHTML={<ReportFooter />}
                          preview={preview}
                          searchTags={searchTags}
                          boundingBoxCoord={boundingBoxCoord}
                          setIsMapLoaded={setIsMapLoaded}
                          isMapLoaded={isMapLoaded}
                          handleMapLoad={handleMapLoad}
                          formValues={formValues}
                          isEditMode={isEditMode}
                          formValuesCheckboxes={formValuesCheckboxes}
                          onSaveChanges={handleSaveChanges}
                          aiRun={aiRun}
                          user={user}
                        />
                      ) : (
                        <div
                          style={{
                            minHeight: "1200px",
                            borderBottom: "20px solid #f5f7fa",
                            position: "relative",
                            paddingBottom: "60px",
                            background: "#fff",
                          }}
                        >
                          <div
                            style={{
                              padding: "20px 20px",
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "50px",
                              borderBottom: "1px solid #333",
                              justifyContent: "space-between",
                              height: "130px",
                            }}
                          >
                            <ReportHeader />
                          </div>
                          <div>
                            <LinearLoading />
                            <h2
                              style={{
                                padding: 50,
                                fontSize: 24,
                                fontWeight: 600,
                                textTransform: "uppercase",
                              }}
                            >
                              <WritingInProgress />
                            </h2>
                          </div>
                        </div>
                      )}
                    </>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </main>
        </div>
        {/* <ModalHeader toggle={toggleModal}>
          <h4 className="contact__title">Personalize and Export</h4>
        </ModalHeader>
        
          <Button
            variant="contained"
            color="secondary"
            onClick={() => toggleDrawer(true)}
            style={{ position: "absolute", top: 10, right: 10 }}
          >
            Open Settings
          </Button> */}

        <div>
          {/* <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
            <div
              id="progress"
              style={{
                color: "#780F9E",
                fontSize: 18,
                fontWeight: 600,
                height: 25,
              }}
            >
              {progress}
            </div>
            <ButtonToolbar className="modal__footer mb-3">
              <Tooltip title="Close">
                <Button
                  onClick={toggleModal}
                  variant="outlined"
                  color=""
                  className="mr-2"
                  startIcon={null}
                >
                  {" "}
                  Close
                </Button>
              </Tooltip>{" "}
              <Tooltip title="Download your PDF report">
                <Button
                  variant="contained"
                  color="primary"
                  className="buyersList__primary-button"
                  startIcon={<FileExportIcon />}
                  onClick={handleExport}
                  disabled={fetchInProgress || aiInProgress}
                  width={200}
                >
                  {" "}
                  {exportInProgress && isMapLoaded
                    ? "Exporting... "
                    : "Download Report"}
                </Button>
              </Tooltip>
            </ButtonToolbar>
          </div> */}

          <Fragment>
            {progress ? (
              <div
                id="progress"
                style={{
                  padding: 20,
                  background: "#FFF",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "60%",
                  height: 75,
                  border: "2px solid #171F26",
                }}
              >
                <Typography
                  variant="h5"
                  noWrap
                  className={classes.drawerHeaderTitle}
                  style={{ textAlign: "center" }}
                >
                  <FileExportIcon
                    size={32}
                    color="#780F9E"
                    style={{ marginTop: -5 }}
                  />{" "}
                  {progress}...
                </Typography>
              </div>
            ) : null}
            <div
              style={{ position: "fixed", bottom: 50, right: 50, zIndex: 9999 }}
            >
              <Tooltip title={`Export Report as PDF`}>
                <Fab
                  variant="extended"
                  size="medium"
                  color="secondary"
                  aria-label="add"
                  className={classes.fab}
                  onClick={handleExport}
                  disabled={fetchInProgress || aiInProgress}
                >
                  <FileExportIcon style={{ marginRight: 5 }} /> {` `}
                  {exportInProgress && isMapLoaded
                    ? "Exporting... "
                    : "Download Report"}
                </Fab>
              </Tooltip>
              <Tooltip title={`Close`}>
                <Fab
                  variant="extended"
                  size="medium"
                  color="secondary"
                  aria-label="add"
                  className={classes.fabClose}
                  onClick={toggleModal}
                  disabled={fetchInProgress || aiInProgress}
                >
                  Close
                </Fab>
              </Tooltip>
            </div>
          </Fragment>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    searchTags: Array.isArray(state.search.searchTags)
      ? state.search.searchTags.slice().map((tag) => {
          if (
            tag.type === "neighborhood" &&
            !tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood.toLowerCase().replace(/\s+/g, "-")}_${
                tag.data.boro
              }`,
            };
          } else if (
            tag.type === "neighborhood" &&
            tag.data.hood.includes("manhattan")
          ) {
            return {
              ...tag,
              id: `${tag.data.hood
                .replace("manhattan", "")
                .trim()
                .toLowerCase()
                .replace(/\s+/g, "-")}_${tag.data.boro}`,
            };
          } else return tag;
        })
      : [],
  };
};

export default connect(mapStateToProps)(ExportModal);
